/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UserRole = "ADMIN" | "%future added value";
export type RemoveUserRoleInput = {
    userId: string;
    role: UserRole;
    clientMutationId?: string | null | undefined;
};
export type userDetailsRemoveUserRoleMutationVariables = {
    input: RemoveUserRoleInput;
};
export type userDetailsRemoveUserRoleMutationResponse = {
    readonly removeUserRole: {
        readonly clientMutationId: string | null;
    } | null;
};
export type userDetailsRemoveUserRoleMutation = {
    readonly response: userDetailsRemoveUserRoleMutationResponse;
    readonly variables: userDetailsRemoveUserRoleMutationVariables;
};



/*
mutation userDetailsRemoveUserRoleMutation(
  $input: RemoveUserRoleInput!
) {
  removeUserRole(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveUserRolePayload",
    "kind": "LinkedField",
    "name": "removeUserRole",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userDetailsRemoveUserRoleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userDetailsRemoveUserRoleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6265055fa320d36509b954941d7cdcff",
    "id": null,
    "metadata": {},
    "name": "userDetailsRemoveUserRoleMutation",
    "operationKind": "mutation",
    "text": "mutation userDetailsRemoveUserRoleMutation(\n  $input: RemoveUserRoleInput!\n) {\n  removeUserRole(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '6ca970957f33c983dfe4ca03b6fcb8b2';
export default node;
